import { useState, useRef, useEffect } from 'react';
import { Button, Form, TextArea, Message, Input } from 'semantic-ui-react'; // Afegit Input
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseUrl } from '@plone/volto/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { reportError, resetReportError } from '../../actions';

import { Captcha } from 'volto-form-block/components/Widget';

const messages = defineMessages({
  report_error: { id: 'Report an error', defaultMessage: 'Informar d’un error' },
  send: { id: 'customer_satisfaction_submit', defaultMessage: 'Enviar comentari' },
  messagePlaceholder: { id: 'report_error_placeholder', defaultMessage: "Explica'ns quin error has trobat i ajuda'ns a millorar el web" },
  thank_you: { id: 'customer_satisfaction_thank_you', defaultMessage: 'Gràcies pels teus comentaris!' },
  comment_label: { id: 'customer_satisfaction_comment_error', defaultMessage: 'El teu comentari' },
  email_label: { id: 'Email (optional)', defaultMessage: 'Correu electrònic (opcional)' },
  email_placeholder: { id: 'report_error_email_placeholder', defaultMessage: 'El teu correu electrònic' },
});


const ReportErrorForm = ({ onOpen, onlyButton, onlyForm, isFormVisible }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  const reportState = useSelector((state) => state.report_error);
  const loading = reportState?.loading;
  const loaded = reportState?.loaded;
  const error = reportState?.error;

  const registryRecord = 'plone.formwidget.recaptcha.interfaces.IReCaptchaSettings.public_key'
  const siteKey = useSelector((state) => state?.registry?.records[registryRecord]);
  const captchaToken = useRef();

  useEffect(() => {
    setMessage('');
    setEmail('');
    dispatch(resetReportError());
  }, [pathname, dispatch]);

  const captcha = new Captcha({
    captchaToken,
    captcha: 'recaptcha',
    captcha_props: {
      public_key: siteKey,
    },
    onChangeFormData: () => {},
  });

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (message.trim()) {
      captcha.verify().then(() => {
        dispatch(
          reportError(getBaseUrl(pathname), { 
            message,
            email,
            'g-recaptcha-response': captchaToken.current 
          })
        );
      }).catch((err) => {
        console.error("Captcha verification failed", err);
      });
    }
    return false;
  };

  const toggleForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onOpen?.(); 
  };

  if (onlyButton) {
    return (
      <Button
        type="button"
        className="customer-satisfaction__btn customer-satisfaction__btn--error"
        active={isFormVisible}
        onClick={toggleForm}
      >
        {intl.formatMessage(messages.report_error)}
        <FontAwesomeIcon icon={faEnvelope} className="ms-3 fs-5" />
      </Button>
    );
  }

  if (onlyForm && isFormVisible) {
    return (
      <div className="report-error-form-section">
        {loaded ? (
          <Message positive className="mt-4">
            <p>{intl.formatMessage(messages.thank_you)}</p>
          </Message>
        ) : (
          <Form onSubmit={onSubmit} loading={loading} className="mt-4" action="#">

            <div className="field">
              <label htmlFor="error-email-input" className="label-email">{intl.formatMessage(messages.email_label)}</label>
              <Input
                id="error-email-input"
                type="email"
                value={email}
                placeholder={intl.formatMessage(messages.email_placeholder)}
                onChange={(e, v) => setEmail(v.value)}
                autoComplete="email"
              />
            </div>

            <div className="comment">
              <label htmlFor="error-message-textarea">{intl.formatMessage(messages.comment_label)}</label>
              <TextArea
                id="error-message-textarea"
                value={message}
                placeholder={intl.formatMessage(messages.messagePlaceholder)}
                onChange={(e, v) => setMessage(v.value)}
                required
              />
            </div>

            {siteKey && captcha.render()}

            {error && <Message negative size="mini" content={error.message || 'Error'} />}
            
            <div className="submit-wrapper">
              <Button 
                type="submit" 
                primary 
                disabled={!message.trim() || loading} 
                content={intl.formatMessage(messages.send)} 
              />
            </div>
          </Form>
        )}
      </div>
    );
  }

  return null;
};

export default ReportErrorForm;
